import React from 'react'
import classNames from 'classnames'

import useHexShade from 'hooks/useHexShade'
import { useStoreSelector, SELECT } from 'providers/StoreProvider'
import { loadThemeColor } from 'utils/color'
import { appParamsService } from 'configuration'

import styles from './MicIndicatorIcon.module.css'

const BUTTON_CONTENT_LOCALE_MAP = {
  en: (
    <g>
      <path
        d="M35.9 33.5c-.4 0-.8.3-.8.7v3.2c0 3.5-2.8 6.3-6.3 6.3s-6.3-2.8-6.3-6.3v-3.1c0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8v3.1c0 4 3.1 7.4 7.1 7.8v4c0 .4.3.8.7.8h.1c.4 0 .8-.3.8-.7v-4.1c4-.4 7-3.8 7.1-7.8v-3.1c0-.4-.3-.8-.7-.8h-.1z"
        className="micls-31"
      />
      <path
        d="M28.8 41.3c-2.3 0-4.3-2.1-4.3-4.6v-8.9c0-2.5 2-4.6 4.3-4.6s4.3 2.1 4.3 4.6v8.9c.1 2.5-1.9 4.6-4.3 4.6.1 0 .1 0 0 0zM33.6 49.9H24c-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8h9.6c.4 0 .8.3.8.8 0 .4-.3.7-.8.8.1 0 0 0 0 0z"
        className="micls-31"
      />
    </g>
  ),
  es: (
    <g>
      <path
        d="M30.7 33.3c-.3 0-.7.3-.7.6v2.7c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4V34c0-.3-.3-.7-.7-.7-.3 0-.7.3-.7.7v2.6c0 3.4 2.6 6.3 6.1 6.7v3.4c0 .3.3.7.6.7h.1c.3 0 .7-.3.7-.6v-3.5c3.4-.3 6-3.2 6.1-6.7V34c0-.4-.3-.7-.7-.7.1 0 0 0 0 0z"
        className="micls-31"
      />
      <path
        d="M24.6 39.9c-2 0-3.7-1.8-3.7-3.9v-7.6c0-2.1 1.7-3.9 3.7-3.9s3.7 1.8 3.7 3.9V36c.1 2.1-1.6 3.9-3.7 3.9.1 0 .1 0 0 0zM28.8 47.3h-8.2c-.3 0-.7-.3-.7-.7 0-.3.3-.7.7-.7h8.2c.3 0 .7.3.7.7-.1.3-.3.6-.7.7z"
        className="micls-31"
      />
      <path
        d="M45.8 33.7v-.2c0-.9-.7-1.4-2-1.4-1.2 0-1.9.4-1.9 1.1 0 .5.3.8 1 .9l2.2.5c1.2.3 1.9.6 2.4 1.1.6.5.8 1.2.8 2.1 0 2.2-1.7 3.6-4.5 3.6-2.9 0-4.6-1.4-4.6-3.8h2.4c0 1.2.7 1.8 2.2 1.8 1.3 0 2-.5 2-1.2 0-.5-.4-.9-1.2-1.1l-2-.5c-1.2-.3-1.9-.6-2.4-1-.6-.5-.9-1.3-.9-2.1 0-2.1 1.6-3.4 4.4-3.4 1.8 0 3 .5 3.7 1.5.4.5.5 1.1.6 2.1h-2.2zM58.1 37.3c0 2.4-1.8 4.1-4.2 4.1-2.4 0-4.2-1.7-4.2-4.2 0-2.4 1.7-4.1 4.2-4.1s4.2 1.7 4.2 4.2zm-6 0c0 1.5.7 2.3 1.9 2.3s1.8-.8 1.8-2.3c0-1.5-.7-2.3-1.9-2.3s-1.8.8-1.8 2.3zM64 35.7c-.1-.6-.6-.9-1.3-.9-.7 0-1.1.3-1.1.7 0 .3.2.4 1 .6l1.5.3c1 .2 1.5.4 1.8.8.4.4.6.9.6 1.6 0 1.7-1.4 2.7-3.5 2.7-2.2 0-3.5-1-3.7-2.8h2.2c.1.7.6 1.1 1.5 1.1.7 0 1.2-.3 1.2-.8 0-.4-.3-.6-.9-.7l-1.4-.3c-1.7-.4-2.4-1-2.4-2.3 0-1.6 1.3-2.5 3.4-2.5 2 0 3.2.9 3.5 2.6H64zM72 35.1h-1.4v3.1c0 1.2 0 1.3.6 1.3h.8v1.7h-1.4c-1 0-1.5-.1-1.9-.5-.4-.4-.5-.8-.5-2v-3.6h-1.1v-1.6h1.1V31h2.3v2.5H72v1.6zM75.3 37.9c.1 1.1.8 1.7 1.8 1.7.6 0 1.1-.2 1.4-.7h2.3c-.4 1.5-1.9 2.5-3.8 2.5-2.4 0-4-1.7-4-4.1 0-2.5 1.6-4.2 4-4.2 1.7 0 2.9.8 3.5 2.3.3.7.4 1.4.4 2.5h-5.6zm3.2-1.6c-.1-.9-.6-1.4-1.5-1.4s-1.5.5-1.7 1.4h3.2zm1-6l-1.8 2.2h-1.6l.8-2.2h2.6zM84.8 33.3v.8c.8-.8 1.3-1 2.2-1 1.7 0 2.8 1.1 2.8 3v5.1h-2.3v-4.3c0-.8 0-1.1-.2-1.4-.2-.3-.5-.5-.9-.5s-.7.1-1 .4c-.3.3-.3.6-.3 1.3v4.4h-2.3v-7.9h2zM103.6 33.3l-2.7 7.9c-.4 1.3-.7 1.7-1.1 2-.4.3-.9.4-1.8.4h-1.4V42h.7c.8 0 1.2-.3 1.2-1 0-.3 0-.3-.3-1l-2.6-6.6h2.5l1.2 3.6.4 1.4.1.3c.1-.5.2-1.1.4-1.8l1-3.6h2.4zM111.9 34c.7-.6 1.3-.9 2.1-.9s1.5.3 2 .8c.5.6.7 1.2.7 2.4v4.8h-2.3v-4.4c0-.7-.1-1-.3-1.3-.2-.3-.5-.4-.9-.4s-.8.1-1 .4c-.3.3-.3.5-.3 1.3v4.4h-2.3V30.3h2.3V34zM118.8 35.8c.1-1.8 1.3-2.7 3.5-2.7 1.2 0 2.1.3 2.7.8.6.5.8 1.1.8 2.3v3.6c0 .8 0 1 .3 1.4h-2.4l-.2-.6c-.8.6-1.3.8-2.2.8-1.7 0-2.9-1-2.9-2.5s.9-2.2 3.1-2.6l1.3-.2c.5-.1.7-.2.7-.5 0-.4-.5-.7-1.2-.7-.8 0-1.3.3-1.4.9h-2.1zm4.7 1.7c-.2.1-.5.2-.8.2l-.8.2c-.8.2-1.2.5-1.2.9 0 .5.4.8 1.2.8.8 0 1.3-.3 1.7-1v-1.1zM127.8 30.3h2.3v3.6c.7-.6 1.4-.8 2.2-.8 2 0 3.4 1.6 3.4 4 0 2.5-1.5 4.3-3.5 4.3-1 0-1.5-.3-2.2-1.1v.9h-2.2V30.3zm2.2 7c0 1.4.7 2.3 1.7 2.3s1.7-.9 1.7-2.2c0-1.4-.6-2.3-1.7-2.3-1-.1-1.7.8-1.7 2.2zM139.6 41.2h-2.3V30.3h2.3v10.9zM141.7 35.8c.1-1.8 1.3-2.7 3.5-2.7 1.2 0 2.1.3 2.7.8.6.5.8 1.1.8 2.3v3.6c0 .8 0 1 .3 1.4h-2.4l-.2-.6c-.8.6-1.3.8-2.2.8-1.7 0-2.9-1-2.9-2.5s.9-2.2 3.1-2.6l1.3-.2c.5-.1.7-.2.7-.5 0-.4-.5-.7-1.2-.7-.8 0-1.3.3-1.4.9h-2.1zm4.7 1.7c-.2.1-.5.2-.8.2l-.8.2c-.8.2-1.2.5-1.2.9 0 .5.4.8 1.2.8.8 0 1.3-.3 1.7-1v-1.1z"
        className="micls-41"
      />
    </g>
  )
}

const BUTTON_ACTIVE_CONTENT_LOCALE_MAP = {
  es: (
    <g>
      <path
        d="M70.9 33.2h-5.4v2h4.7V37h-4.7v2.5H71v2h-7.9V31.2h7.8v2zM76.7 36.3c-.1-.6-.5-.9-1.3-.9-.6 0-1.1.2-1.1.6 0 .3.2.4.9.6l1.4.3c.9.2 1.4.4 1.7.7.4.3.6.9.6 1.5 0 1.6-1.3 2.6-3.4 2.6s-3.4-1-3.5-2.7h2.1c.1.7.6 1 1.5 1 .7 0 1.2-.3 1.2-.7 0-.4-.2-.5-.8-.7l-1.4-.3c-1.7-.4-2.3-1-2.3-2.2 0-1.5 1.2-2.4 3.2-2.4 1.9 0 3.1.9 3.3 2.5h-2.1zM85.3 36.8c-.1-.7-.6-1.1-1.4-1.1-1 0-1.6.8-1.6 2.1 0 1.5.5 2.2 1.6 2.2.8 0 1.2-.4 1.4-1.3l2.2.1c-.3 1.9-1.6 3-3.6 3-2.3 0-3.7-1.5-3.7-3.9 0-2.5 1.4-4 3.8-4 2 0 3.3 1.1 3.5 2.9h-2.2zM95.7 41.6h-2.1v-.8c-.5.7-1.1 1-2 1-.8 0-1.5-.3-2-.8s-.7-1.2-.7-2.2v-4.7h2.2v4.2c0 .7 0 .9.2 1.2.2.3.6.4 1 .4s.7-.2 1-.4c.2-.3.2-.4.2-1.2v-4.2h2.2v7.5zM102.5 36.8c-.1-.7-.6-1.1-1.4-1.1-1 0-1.6.8-1.6 2.1 0 1.5.5 2.2 1.6 2.2.8 0 1.2-.4 1.4-1.3l2.2.1c-.3 1.9-1.6 3-3.6 3-2.3 0-3.7-1.5-3.7-3.9 0-2.5 1.4-4 3.8-4 2 0 3.3 1.1 3.5 2.9h-2.2zM108.3 34.7c.6-.6 1.2-.8 2-.8s1.5.3 1.9.8c.5.5.7 1.2.7 2.3v4.6h-2.2v-4.2c0-.7-.1-1-.2-1.2-.2-.2-.5-.4-.9-.4s-.7.1-1 .4c-.2.3-.3.5-.3 1.3v4.2h-2.2V31.2h2.2v3.5zM114.9 36.4c.1-1.7 1.2-2.6 3.3-2.6 1.1 0 2 .3 2.6.8.5.5.7 1.1.7 2.2v3.5c0 .8 0 .9.3 1.3h-2.3l-.2-.6c-.7.6-1.3.8-2.2.8-1.7 0-2.8-.9-2.8-2.4 0-1.4.9-2.2 3-2.5l1.2-.2c.5-.1.7-.2.7-.5 0-.4-.4-.7-1.2-.7-.8 0-1.2.3-1.3.9h-1.8zm4.6 1.6c-.2.1-.4.2-.8.2l-.8.2c-.8.2-1.1.5-1.1.9 0 .5.4.8 1.1.8.7 0 1.3-.3 1.6-1V38zM125.7 34.1v.7c.8-.7 1.3-1 2.1-1 1.6 0 2.6 1.1 2.6 2.9v4.9h-2.2v-4.1c0-.8 0-1.1-.2-1.3-.2-.3-.5-.4-.9-.4s-.7.1-1 .4c-.2.3-.3.6-.3 1.2v4.2h-2.2v-7.5h2.1zM139.5 41.6h-2.1v-.8c-.6.7-1.2 1-2.1 1-2 0-3.3-1.6-3.3-4s1.3-4 3.4-4c.8 0 1.4.2 1.9.8v-3.4h2.2v10.4zm-5.3-3.8c0 1.3.6 2.2 1.6 2.2s1.6-.9 1.6-2.2c0-1.3-.6-2.2-1.6-2.2s-1.6.9-1.6 2.2zM149.1 37.9c0 2.3-1.7 3.9-4 3.9s-4-1.6-4-4c0-2.3 1.7-4 4-4 2.4.1 4 1.7 4 4.1zm-5.8-.1c0 1.4.6 2.2 1.8 2.2 1.1 0 1.8-.8 1.8-2.2 0-1.5-.6-2.2-1.8-2.2-1.1 0-1.8.8-1.8 2.2z"
        className="micls-3"
      />
    </g>
  )
}

const { isHoldToTalkV2 } = appParamsService
const englishButtonText = isHoldToTalkV2 ? 'Press to Talk' : 'Hold to Talk'

const MicIndicatorIcon = ({
  isActive,
  className = '',
  innerDotClassName = '',
  outerDotClassName = '',
  middleDotClassName = '',
  textContainerClassName = '',
  textClassName = ''
}) => {
  const { appLocale } = useStoreSelector(SELECT.LANGUAGE)
  const micIndicatorColor = loadThemeColor('--mic-indicator-color')
  const { hex: gradientColor } = useHexShade(-0.2, micIndicatorColor)
  const isEnglish = appLocale === 'en'

  return (
    <>
      <svg
        width="150"
        height="55"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="10 15 150 55"
        xmlSpace="preserve"
        className={className}
      >
        <defs>
          <style type="text/css">
            {`.micls-11 { fill:${micIndicatorColor}; }
	          .micls-31 { fill:#FFFFFF; }
	          .micls-41 { fill:#FFFFFF; stroke:#FFFFFF; stroke-width:0.2; stroke-miterlimit:10; }
            .micls-51 { fill:url(#linear-gradient); }
            .micls-3{fill:#FFFFFF;}
            `}
          </style>
          <linearGradient
            id="linear-gradient"
            x1="83.45"
            y1="54.36"
            x2="83.45"
            y2="18.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor={gradientColor} stopOpacity="0" />
            <stop offset="0.03" stopColor={gradientColor} stopOpacity="0.16" />
            <stop offset="0.1" stopColor={gradientColor} stopOpacity="0.46" />
            <stop offset="0.17" stopColor={gradientColor} stopOpacity="0.69" />
            <stop offset="0.23" stopColor={gradientColor} stopOpacity="0.86" />
            <stop offset="0.29" stopColor={gradientColor} stopOpacity="0.96" />
            <stop offset="0.33" stopColor={gradientColor} />
            <stop offset="0.71" stopColor={gradientColor} />
            <stop offset="0.74" stopColor={gradientColor} stopOpacity="0.95" />
            <stop offset="0.79" stopColor={gradientColor} stopOpacity="0.83" />
            <stop offset="0.86" stopColor={gradientColor} stopOpacity="0.62" />
            <stop offset="0.93" stopColor={gradientColor} stopOpacity="0.33" />
            <stop offset="1" stopColor={gradientColor} stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M148.7 57H18.2c-4.4 0-8-3.6-8-8V24c0-4.4 3.6-8 8-8h130.4c4.4 0 8 3.6 8 8v25c.1 4.4-3.5 8-7.9 8z"
          className="micls-11"
        ></path>
        <path d="M33 69.6L50.8 57 33 57z" className="micls-11"></path>
        <rect className="micls-51" x="10.23" y="15.96" width="146.44" height="41.07" rx="8" />
        {!isEnglish && (
          <g className={classNames({ [styles.visible]: isActive, [styles.hidden]: !isActive })}>
            {BUTTON_ACTIVE_CONTENT_LOCALE_MAP[appLocale]}
          </g>
        )}
        <g className={classNames({ [styles.visible]: !isActive, [styles.hidden]: isActive })}>
          {BUTTON_CONTENT_LOCALE_MAP[appLocale]}
        </g>
      </svg>
      {/* @TODO: Switch the rest of locales to using text instead of svg paths  */}
      {isEnglish && (
        <div className={classNames(styles.buttonTextContainer, textContainerClassName)}>
          <div className={classNames(styles.buttonText, textClassName)}>
            {isActive ? 'Listening' : englishButtonText}
          </div>
        </div>
      )}
      {isActive && (
        <>
          <div
            className={classNames(styles.listeningIndicator, styles.outerDot, outerDotClassName)}
          />
          <div
            className={classNames(styles.listeningIndicator, styles.middleDot, middleDotClassName)}
          />
          <div
            className={classNames(styles.listeningIndicator, styles.innerDot, innerDotClassName)}
          />
        </>
      )}
    </>
  )
}

export default MicIndicatorIcon
